const riot = require('riot');

riot.tag2('module-page-header', '<div class="f fbw fm h72 px36 elevation-default-mid bg-white"> <div class="f fm"> <div class="cursor-pointer px8 py12 mr22" if="{opts.back}" onclick="{onclick}"><i class="icon-arrow-left fs20 text-gray_80"></i></div> <div> <div class="mb2" if="{opts.breadcrumbs}" data-is="module-breadcrumbs" items="{opts.breadcrumbs}"></div> <div class="f fm"> <div class="ts-hl text-navy word-break-all line-clamp-1 mr16">{opts.title}</div> <yield from="badge"></yield> </div> </div> </div> <yield from="right"></yield> </div>', '', '', function(opts) {
    this.onclick = () => {
      if (this.opts.back === true) {
        history.back();
        return;
      }
      spat.router.push(opts.back);
    };
});